// src/store/modules/rangeBoxGeneral/actions.js
import RangeBoxGeneralApi from "../../../api/modules/RangeBoxGeneralApi";

export const listRangeBoxByOrder = ({ commit }, { context, idOrder }) => {
  return RangeBoxGeneralApi.listRangeBoxByOrder(context, idOrder);
};



// WEBPACK FOOTER //
// ./src/store/modules/rangeBoxGeneral/actions.js